import script from "./CouponPopup.vue?vue&type=script&setup=true&lang=js"
export * from "./CouponPopup.vue?vue&type=script&setup=true&lang=js"

import "./CouponPopup.vue?vue&type=style&index=0&id=8ee8572c&lang=less&scoped=true"

import exportComponent from "C:\\Users\\11920\\Desktop\\vue_db\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8ee8572c"]])

export default __exports__